// Removes all whitespace and makes lowercase
export default function (couponCode) {
  return couponCode.replace(/\s/g, '').toLowerCase();
}
